import EvenMorePain from "./EvenMorePain";
import LittlePain from "./LittlePain";
import LotOfPain from "./LotOfPain";
import MorePain from "./MorePain";
import WorstPain from "./WorstPain";
import NoPain from "./NoPain";

export const painFaces = {
    EvenMorePain,
    LittlePain,
    LotOfPain,
    MorePain,
    WorstPain,
    NoPain,
};
